import { SearchType } from '@zoopla/listing-search-context';
import { Page, getServerSidePropsFor } from '@zoopla/listing-search/factory';

export const getServerSideProps = getServerSidePropsFor(
    SearchType.ToRent,
    process.env.NEXT_PUBLIC_DIRECT_LSRP_DATA_FETCH === 'true'
);

export default Page;
